import React, { useState } from "react";
import { Button, Checkbox, Form, Input, Modal, Select, Space, Switch, Upload, Image } from 'antd';
import { MinusCircleOutlined, PlusOutlined, UploadOutlined, ArrowLeftOutlined } from '@ant-design/icons';
import { menuItems } from "../../utils/constants";
import { assignLanguage, imageSizeFromBase64, getBase64, errorMessage, imageSizeFromBase642, getBase642 } from "../../utils/helpers";
import { useSelector } from "react-redux";
import logoImg from "../../assets/Images/logoForContentForm.png"
import countryNameHome from "../../assets/Images/countryNameHome.jpeg"
import homeHeading from "../../assets/Images/homeHeading.jpeg"
import homeBackground from "../../assets/Images/homeBackground.jpeg"
import HomeModal from "./HomeModal";
import drNameImg from "../../assets/Images/drNameImg.jpeg"
import drDescriptionImg from "../../assets/Images/drDescriptionImg.jpeg"
import drImg from "../../assets/Images/drImg.jpeg"
import drPrimedentImg from "../../assets/Images/premidentRoleImg.jpeg"
import serviceNameImg from "../../assets/Images/serviceNameImg.jpeg"
import serviceLogoImg from "../../assets/Images/serviceLogoImg.jpeg"
import serviceDescriptionImg from "../../assets/Images/serviceDescriptionImg.jpeg"
import specialServiceNameImg from "../../assets/Images/specialServiceName.jpeg"
import specialServiceImg from "../../assets/Images/specialServiceImg.jpeg"
import specialServiceDescriptionImg from "../../assets/Images/specialServiceDescriptionImg.jpeg"
import patientNameImg from "../../assets/Images/patientNameImg.jpeg"
import patientCaptionImg from "../../assets/Images/patientCaptionImg.jpeg"
import patientImg from "../../assets/Images/patientImg.jpeg"
import egyptDescriptionImg from "../../assets/Images/egyptDescription.jpeg"
import egyptImg from "../../assets/Images/egyptImg.jpeg"
import egyptTitleImg from "../../assets/Images/egyptTitleImg.jpeg"
import egyptVideoImg from "../../assets/Images/egyptVideoImg.jpeg"
import clinicNameImg from "../../assets/Images/clinicNameImg.jpeg"
import clinicAddressImg from "../../assets/Images/clinicAddressImg.jpeg"
import clinicEmailImg from "../../assets/Images/clinicEmailImg.jpeg"
import clinicNumberImg from "../../assets/Images/clinicNumberImg.jpeg"
import { MdOutlineRemoveCircle, MdOutlineAddCircle } from "react-icons/md";

const { Option } = Select

const ContentFormHome = ({ path, setPath, props }) => {
    const language = useSelector(state => state?.languageReducer)
    const selectedLanguage = assignLanguage(language?.language)
    const isELSelect = language?.language === 'english'
    const isAlSelect = language?.language === 'arabic'
    const [form] = Form.useForm()
    const [modalVisible, setModalVisible] = useState(false)
    const [dataForModal, setDataForModal] = useState()
    const [showForm, setShowForm] = useState(true)
    const [fileDimensions] = useState({
        logo: { height: 24, width: 134 },
        sliderImage: { height: 750, width: 1920 },
        drPicture: { height: 355, width: 720 },
        feedbackImg: { height: 550, width: 1920 },
        egyptImg: { height: 310, width: 370 },
    });
    const [fileDimensions2] = useState({
        serviceLogo: { height: 62, width: 69 },
        serviceImg: { height: 200, width: 570 },
    });
    const showModal = () => {
        setModalVisible(true)
    }

    const handleCancel = () => {
        setModalVisible(false)
    }
    const handleChange = (value) => {
        setPath(value);
        console.log('value', value)
    };
    const onFinish = async (values) => {
        let formData = new FormData()
        console.log('formData', values)
        setDataForModal(values)

    }
    const normFile = (e, fieldName) => {
        if (e?.fileList?.length) {
            getBase64(e.file, async (url) => {
                const imageSize = await imageSizeFromBase64(url);
                const { height, width } = imageSize;

                const { height: reqHeight, width: reqWidth } = fileDimensions[fieldName] || {};

                if (height !== reqHeight || width !== reqWidth) {
                    form.setFieldsValue({ [fieldName]: [] });
                    errorMessage(
                        `The image for ${fieldName} must be ${reqHeight}px in height and ${reqWidth}px in width.`
                    );
                    return [];
                }
            });
        }

        const size = e?.file?.size / 1000;
        if (size > 1000) {
            errorMessage('File size should be less than 1MB.');
            return [];
        }
        if (e?.fileList?.length && !e?.file?.type.includes('image')) {
            errorMessage('You can only upload images.');
            return [];
        }

        if (Array.isArray(e)) {
            return e;
        }

        return e?.fileList;
    };

    const normFile2 = async (file, fieldName) => {
        const url = await getBase642(file);
        const imageSize = await imageSizeFromBase642(url);
        const { height, width } = imageSize;

        const { height: reqHeight, width: reqWidth } = fileDimensions2[fieldName] || {};

        if (height !== reqHeight || width !== reqWidth) {
            errorMessage(`The image for ${fieldName} must be ${reqHeight}px in height and ${reqWidth}px in width.`);
            return false;
        }

        const size = file.size / 1024;
        if (size > 1000) {
            errorMessage('File size should be less than 1MB.');
            return false;
        }

        if (!file.type.includes('image')) {
            errorMessage('You can only upload images.');
            return false;
        }

        return true;
    };
    return (
        <div className="main">
            <div className="content-form">
                <div className="content-form-heading-div">
                    <h2 className="content-form-heading">
                        {selectedLanguage?.txt_content_form_home}
                    </h2>
                    {showForm ? <button onClick={() => setShowForm(false)}>
                        <MdOutlineRemoveCircle className="content-form-icon" />Remove
                    </button>
                        :
                        <button onClick={() => setShowForm(true)}>
                            <MdOutlineAddCircle className="content-form-icon" />Add
                        </button>}
                </div>
                <Form
                    initialValues={{ screen: path }}
                    form={form}
                    onFinish={onFinish}
                    layout='vertical'
                    requiredMark={true}
                >
                    <div>
                        <Form.Item
                            name='screen'
                            label={selectedLanguage?.txt_select_screen}
                            rules={[
                                {
                                    required: true,
                                },
                            ]}
                        >
                            <Select
                                showArrow
                                showSearch
                                allowClear
                                placeholder={selectedLanguage?.txt_select_screen}
                                optionFilterProp='children'
                                filterOption={true}
                                onChange={handleChange}
                            >
                                {menuItems.slice(0, -1).map((item, index) => (
                                    <Option key={index} value={item.menuName}>
                                        {isELSelect ? item?.menuName : (isAlSelect ? item?.menuALName : item?.menuGLName)}
                                    </Option>
                                ))}
                            </Select>
                        </Form.Item>
                    </div>
                    {showForm ?
                        <div>
                            <div>
                                <Form.Item
                                    className="content-form-logo-div"
                                    label={selectedLanguage?.txt_add_logo}
                                    name="logo"
                                    valuePropName="fileList"
                                    getValueFromEvent={(e) => normFile(e, 'logo')}
                                    extra="Please upload an image with dimensions (Height: 24px, Width: 134px)"
                                >
                                    <Upload
                                        multiple={false}
                                        maxCount={1}
                                        accept="image/*"
                                        beforeUpload={() => false}
                                    >
                                        <Button className="logo-upload-btn" icon={<UploadOutlined />}>
                                            {selectedLanguage?.txt_upload}
                                        </Button>
                                    </Upload>
                                </Form.Item>
                                <Image
                                    width={150}
                                    src={logoImg}
                                />
                            </div>
                            <div className="content_sections_div">
                                <h2>{selectedLanguage?.txt_slider_section}</h2>
                                <Form.Item
                                    className="content_inputs"
                                    name='sliderHeading'
                                    label={selectedLanguage?.heading_label}
                                >
                                    <Input placeholder={selectedLanguage?.heading_label} />
                                </Form.Item>
                                <Image
                                    width={150}
                                    src={homeHeading}
                                />
                                <Form.Item
                                    className="content_inputs"
                                    name='sliderCountryName'
                                    label={selectedLanguage?.country_name}
                                >
                                    <Input placeholder={selectedLanguage?.country_name} />
                                </Form.Item>
                                <Image
                                    width={150}
                                    src={countryNameHome}
                                />
                                <Form.Item
                                    className="content-form-logo-div"
                                    label={selectedLanguage?.Add_home_page}
                                    name='sliderImage'
                                    valuePropName='fileList'
                                    getValueFromEvent={(e) => normFile(e, 'sliderImage')}
                                    extra="Please upload an image with dimensions (Height: 750px, Width: 1920px)"
                                >
                                    <Upload
                                        maxCount={2}
                                        multiple={true}
                                        accept='image/*'
                                        name='sliderImage'
                                        action='/upload.do'
                                        listType='text'
                                        beforeUpload={() => false}
                                    >
                                        <Button icon={<UploadOutlined />}>{selectedLanguage?.txt_upload}</Button>
                                    </Upload>
                                </Form.Item>
                                <Image
                                    width={150}
                                    src={homeBackground}
                                />
                            </div>
                            <div className="content_sections_div">
                                <h2>
                                    {selectedLanguage?.Doctor_section}
                                </h2>
                                <div className="content-form-doctor-section">
                                    <Form.Item
                                        className="content_inputs"
                                        name='drName'
                                        label={selectedLanguage?.name_label}
                                        required
                                    >
                                        <Input placeholder={selectedLanguage?.name_label} />
                                    </Form.Item>
                                    <Image
                                        width={150}
                                        src={drNameImg}
                                    />
                                    <Form.Item
                                        className="content_inputs"
                                        name='primadentRoleTitle'
                                        label={selectedLanguage?.txt_primadent_role}
                                        required
                                    >
                                        <Input placeholder={selectedLanguage?.txt_primadent_role} />
                                    </Form.Item>
                                    <Image
                                        width={150}
                                        src={drPrimedentImg}
                                    />
                                    <Form.Item
                                        className="content_inputs"
                                        name='drDescription'
                                        label={selectedLanguage?.txt_description}
                                        required
                                    >
                                        <Input.TextArea autoSize={{ minRows: 2 }} placeholder={selectedLanguage?.txt_description} />
                                    </Form.Item>
                                    <Image
                                        width={150}
                                        src={drDescriptionImg}
                                    />
                                    <Form.Item
                                        className="content-form-logo-div"
                                        label={selectedLanguage?.txt_upload_doctor_image}
                                        name='drPicture'
                                        valuePropName='fileList'
                                        getValueFromEvent={(e) => normFile(e, 'drPicture')}
                                        extra="Please upload an image with dimensions (Height: 355px, Width: 720px)"
                                    >
                                        <Upload
                                            maxCount={1}
                                            multiple={true}
                                            accept='image/*'
                                            name='drPicture'
                                            action='/upload.do'
                                            listType='text'
                                            beforeUpload={() => false}
                                        >
                                            <Button icon={<UploadOutlined />}>{selectedLanguage?.txt_upload}</Button>
                                        </Upload>
                                    </Form.Item>
                                    <Image
                                        width={150}
                                        src={drImg}
                                    />
                                </div>
                            </div>
                            <div className="content_sections_div">
                                <h2>{selectedLanguage?.txt_services_section}</h2>
                                <Form.List name='homeServiceItem' initialValue={[{ serviceName: null, serviceDescription: null, serviceLogo: null, specialServiceName: null, specialServiceNameDescription: null, serviceImg: null }]}>
                                    {(fields, { add, remove }) => (
                                        <>
                                            {fields.map(({ key, name, ...restField }) => (
                                                <Space
                                                    className="formList-main"
                                                    key={key}
                                                    style={{
                                                        display: 'flex',
                                                        marginBottom: 8,
                                                        flexWrap: 'wrap'
                                                    }}
                                                >
                                                    <Form.Item
                                                        className="content_inputs"
                                                        {...restField}
                                                        name={[name, 'serviceName']}
                                                        label={selectedLanguage?.txt_label_service_name}
                                                    >
                                                        <Input placeholder={selectedLanguage?.txt_label_service_name} />
                                                    </Form.Item>
                                                    <Image
                                                        width={150}
                                                        src={serviceNameImg}
                                                    />
                                                    <Form.Item
                                                        className="content_inputs"
                                                        {...restField}
                                                        name={[name, 'serviceDescription']}
                                                        label={selectedLanguage?.txt_description}
                                                    >
                                                        <Input.TextArea autoSize={{ minRows: 2 }} placeholder={selectedLanguage?.txt_description} />
                                                    </Form.Item>
                                                    <Image
                                                        width={150}
                                                        src={serviceDescriptionImg}
                                                    />
                                                    <Form.Item
                                                        className="content-form-logo-div"
                                                        {...restField}
                                                        label={selectedLanguage?.txt_service_logo}
                                                        name={[name, 'serviceLogo']}
                                                        valuePropName="fileList"
                                                        getValueFromEvent={(e) => {
                                                            return e.fileList || [];
                                                        }}
                                                        extra="Please upload an image with dimensions (Height: 62px, Width: 69px)"
                                                    >
                                                        <Upload
                                                            maxCount={1}
                                                            multiple={false}
                                                            accept="image/*"
                                                            beforeUpload={async (file) => {
                                                                const isValid = await normFile2(file, 'serviceLogo');
                                                                return isValid ? false : Upload.LIST_IGNORE;
                                                            }}
                                                            onChange={(info) => {
                                                                form.setFieldsValue({
                                                                    homeServiceItem: form.getFieldValue('homeServiceItem').map((item, index) => {
                                                                        if (index === key) {
                                                                            return { ...item, serviceLogo: info.fileList };
                                                                        }
                                                                        return item;
                                                                    }),
                                                                });
                                                            }}
                                                        >
                                                            <Button icon={<UploadOutlined />}>Upload</Button>
                                                        </Upload>
                                                    </Form.Item>
                                                    <Image
                                                        width={150}
                                                        src={serviceLogoImg}
                                                    />
                                                    <Form.Item
                                                        className="content_inputs"
                                                        {...restField}
                                                        name={[name, 'specialServiceName']}
                                                        label={selectedLanguage?.txt_special_service_name}
                                                    >
                                                        <Input placeholder={selectedLanguage?.txt_label_service_name} />
                                                    </Form.Item>
                                                    <Image
                                                        width={150}
                                                        src={specialServiceNameImg}
                                                    />
                                                    <Form.Item
                                                        className="content_inputs"
                                                        {...restField}
                                                        name={[name, 'specialServiceNameDescription']}
                                                        label={selectedLanguage?.txt_service_description}
                                                    >
                                                        <Input.TextArea autoSize={{ minRows: 2 }} placeholder={selectedLanguage?.txt_description} />
                                                    </Form.Item>
                                                    <Image
                                                        width={150}
                                                        src={specialServiceDescriptionImg}
                                                    />
                                                    <Form.Item
                                                        className="content-form-logo-div"
                                                        {...restField}
                                                        label={selectedLanguage?.txt_service_image}
                                                        name={[name, 'serviceImg']}
                                                        valuePropName='fileList'
                                                        getValueFromEvent={(e) => {
                                                            return e.fileList || [];
                                                        }}
                                                        extra="Please upload an image with dimensions (Height: 200px, Width: 570px)"
                                                    >
                                                        <Upload
                                                            maxCount={1}
                                                            multiple={false}
                                                            accept='image/*'
                                                            beforeUpload={async (file) => {
                                                                const isValid = await normFile2(file, 'serviceImg');
                                                                return isValid ? false : Upload.LIST_IGNORE;
                                                            }}
                                                            onChange={(info) => {
                                                                form.setFieldsValue({
                                                                    homeServiceItem: form.getFieldValue('homeServiceItem').map((item, index) => {
                                                                        if (index === key) {
                                                                            return { ...item, serviceImg: info.fileList };
                                                                        }
                                                                        return item;
                                                                    }),
                                                                });
                                                            }}
                                                        >
                                                            <Button icon={<UploadOutlined />}>{selectedLanguage?.upload_Button}</Button>
                                                        </Upload>
                                                    </Form.Item>
                                                    <Image
                                                        width={150}
                                                        src={specialServiceImg}
                                                    />
                                                    {
                                                        fields.length > 1 ?
                                                            <span style={name ? { marginTop: -25, position: 'absolute' } : {}}>
                                                                <MinusCircleOutlined onClick={() => remove(name)} />
                                                            </span>
                                                            :
                                                            null
                                                    }
                                                </Space>
                                            ))}
                                            <Form.Item>
                                                <Button type='dashed' onClick={() => add()} block icon={<PlusOutlined />}>
                                                    {selectedLanguage?.add_button_txt}
                                                </Button>
                                            </Form.Item>
                                        </>
                                    )}
                                </Form.List>
                            </div>
                            <div className="content_sections_div">
                                <h2>{selectedLanguage?.txt_feedback_Section}</h2>
                                <Form.Item
                                    className="content-form-logo-div"
                                    label={selectedLanguage?.txt_feedback_bg_img}
                                    name='feedbackImg'
                                    valuePropName='fileList'
                                    getValueFromEvent={(e) => normFile(e, 'feedbackImg')}
                                    extra="Please upload an image with dimensions (Height: 550px, Width: 1920px)"
                                >
                                    <Upload
                                        maxCount={1}
                                        multiple={false}
                                        accept='image/*'
                                        name='feedbackImg'
                                        action='/upload.do'
                                        listType='text'
                                        beforeUpload={() => false}
                                    >
                                        <Button icon={<UploadOutlined />}>{selectedLanguage?.upload_Button}</Button>
                                    </Upload>
                                </Form.Item>
                                <Image
                                    width={150}
                                    src={patientImg}
                                />
                                <Form.List name='homeFeedbackItem' initialValue={[{ feedbackName: null, upload: null, feedbackCaption: null }]}>
                                    {(fields, { add, remove }) => (
                                        <>
                                            {fields.map(({ key, name, ...restField }) => (

                                                <Space
                                                    className="formList-main"
                                                    key={key}
                                                    style={{
                                                        display: 'flex',
                                                        marginBottom: 8,
                                                        flexWrap: 'wrap'
                                                    }}
                                                >
                                                    <Form.Item
                                                        className="content_inputs"
                                                        {...restField}
                                                        name={[name, 'feedbackName']}
                                                        label={selectedLanguage?.name_label}
                                                    >
                                                        <Input placeholder={selectedLanguage?.name_label} />
                                                    </Form.Item>
                                                    <Image
                                                        width={150}
                                                        src={patientNameImg}
                                                    />
                                                    <Form.Item
                                                        className="content_inputs"
                                                        {...restField}
                                                        name={[name, 'feedbackCaption']}
                                                        label={selectedLanguage?.txt_caption}
                                                    >
                                                        <Input.TextArea autoSize={{ minRows: 2 }} placeholder={selectedLanguage?.txt_caption} />
                                                    </Form.Item>
                                                    <Image
                                                        width={150}
                                                        src={patientCaptionImg}
                                                    />
                                                    {fields.length > 1 ?
                                                        <span style={name ? { marginTop: -25, position: 'absolute' } : {}}>
                                                            <MinusCircleOutlined onClick={() => remove(name)} />
                                                        </span>
                                                        :
                                                        null
                                                    }
                                                </Space>
                                            ))}
                                            <Form.Item>
                                                <Button type='dashed' onClick={() => add()} block icon={<PlusOutlined />}>
                                                    {selectedLanguage?.add_button_txt}
                                                </Button>
                                            </Form.Item>
                                        </>
                                    )}
                                </Form.List>
                            </div>
                            <div className="content_sections_div">
                                <h2>{selectedLanguage?.txt_egypt_section}</h2>
                                <Form.Item
                                    className="content_inputs"
                                    name='egyptDescription'
                                    label={selectedLanguage?.txt_description}
                                >
                                    <Input.TextArea autoSize={{ minRows: 2 }} placeholder={selectedLanguage?.txt_description} />
                                </Form.Item>
                                <Image
                                    width={150}
                                    src={egyptDescriptionImg}
                                />
                                <Form.Item
                                    className="content-form-logo-div"
                                    label={selectedLanguage?.txt_you_can_add_multiple_egypt_images}
                                    name='egyptImg'
                                    valuePropName='fileList'
                                    getValueFromEvent={(e) => normFile(e, 'egyptImg')}
                                    extra="Please upload an image with dimensions (Height: 310px, Width: 370px)"
                                >
                                    <Upload
                                        maxCount={3}
                                        multiple={true}
                                        accept='image/*'
                                        name='egyptImg'
                                        action='/upload.do'
                                        listType='text'
                                        beforeUpload={() => false}
                                    >
                                        <Button icon={<UploadOutlined />}>{selectedLanguage?.txt_upload}</Button>
                                    </Upload>
                                </Form.Item>
                                <Image
                                    width={150}
                                    src={egyptImg}
                                />
                                <Form.Item
                                    className="content_inputs"
                                    name='egyptVideoTitle'
                                    label={selectedLanguage?.txt_video_description}
                                >
                                    <Input.TextArea autoSize={{ minRows: 2 }} placeholder={selectedLanguage?.txt_video_description} />
                                </Form.Item>
                                <Image
                                    width={150}
                                    src={egyptTitleImg}
                                />
                                <Form.Item
                                    className="content-form-logo-div"
                                    label={selectedLanguage?.txt_upload_video}
                                    name='egyptVideo'
                                    valuePropName='fileList'
                                    getValueFromEvent={normFile}
                                >
                                    <Upload
                                        multiple={true}
                                        maxCount={1}
                                        accept='video/*'
                                        name='egyptVideo'
                                        action='/upload.do'
                                        listType='text'
                                        beforeUpload={() => false}
                                    >
                                        <Button icon={<UploadOutlined />}>{selectedLanguage?.upload_Button}</Button>
                                    </Upload>
                                </Form.Item>
                                <Image
                                    width={150}
                                    src={egyptVideoImg}
                                />
                            </div >
                            <div className="content_sections_div">
                                <h2>{selectedLanguage?.txt_footer_section}</h2>
                                <Form.List name='footerItems' initialValue={[{ clinicName: null, address: null, email: null, number: null }]}>
                                    {(fields, { add, remove }) => (
                                        <>
                                            {fields.map(({ key, name, ...restField }) => (

                                                <Space
                                                    className="formList-main"
                                                    key={key}
                                                    style={{
                                                        display: 'flex',
                                                        marginBottom: 8,
                                                        flexWrap: 'wrap'
                                                    }}
                                                >
                                                    <Form.Item
                                                        className="content_inputs"
                                                        {...restField}
                                                        name={[name, 'clinicName']}
                                                        label={selectedLanguage?.txt_clinic_name}
                                                    >
                                                        <Input placeholder={selectedLanguage?.txt_clinic_name} />
                                                    </Form.Item>
                                                    <Image
                                                        width={150}
                                                        src={clinicNameImg}
                                                    />
                                                    <Form.Item
                                                        className="content_inputs"
                                                        {...restField}
                                                        name={[name, 'address']}
                                                        label={selectedLanguage?.txt_address}
                                                    >
                                                        <Input placeholder={selectedLanguage?.txt_address} />
                                                    </Form.Item>
                                                    <Image
                                                        width={150}
                                                        src={clinicAddressImg}
                                                    />
                                                    <Form.Item
                                                        className="content_inputs"
                                                        {...restField}
                                                        name={[name, 'email']}
                                                        label={selectedLanguage?.email_placeholder}
                                                    >
                                                        <Input placeholder={selectedLanguage?.email_placeholder} />
                                                    </Form.Item>
                                                    <Image
                                                        width={150}
                                                        src={clinicEmailImg}
                                                    />
                                                    <Form.Item
                                                        className="content_inputs"
                                                        {...restField}
                                                        name={[name, 'number']}
                                                        label={selectedLanguage?.txt_number}
                                                    >
                                                        <Input placeholder={selectedLanguage?.txt_number} />
                                                    </Form.Item>
                                                    <Image
                                                        width={150}
                                                        src={clinicNumberImg}
                                                    />
                                                    {fields.length > 1 ?
                                                        <span style={name ? { marginTop: -25, position: 'absolute' } : {}}>
                                                            <MinusCircleOutlined onClick={() => remove(name)} />
                                                        </span>
                                                        :
                                                        null
                                                    }
                                                </Space>
                                            ))}
                                            <Form.Item>
                                                <Button type='dashed' onClick={() => add()} block icon={<PlusOutlined />}>
                                                    {selectedLanguage?.add_button_txt}
                                                </Button>
                                            </Form.Item>
                                        </>
                                    )}
                                </Form.List>
                            </div>
                            <Form.Item
                                className="content_inputs"
                                name='remark'
                                label={selectedLanguage?.txt_remark}
                                rules={[
                                    {
                                        required: true,
                                        message: '',
                                    }
                                ]}
                                required
                            >
                                <Input.TextArea autoSize={{ minRows: 2 }} placeholder={selectedLanguage?.txt_remark} />
                            </Form.Item>
                            <Form.Item >
                                {/* <Button
                            onClick={showModal}
                            htmlType='submit'
                            style={{ borderRadius: 4, width: '100%', marginBottom: '20px' }}
                        // type='primary'
                        // loading={loading}
                        >
                            {'Preview'}
                        </Button> */}
                                <Button
                                    htmlType='submit'
                                    style={{ borderRadius: 4, width: '100%' }}
                                    type='primary'
                                // loading={loading}
                                >
                                    {selectedLanguage?.submit_button}
                                </Button>
                            </Form.Item>
                        </div>
                        : null}
                </Form>
                {/* <HomeModal dataForModal={dataForModal} visible={modalVisible} onCancel={handleCancel} /> */}
            </div >
        </div >
    )
}

export default ContentFormHome